import { useFormContext } from 'react-hook-form';
import { FormValues } from '.';
import { SelectSimple } from '../../components/Select';

type Props = {
  outputId: string;
};

export function XChatAccessField(props: Props) {
  const outputsForm = useFormContext<FormValues>();
  const chatAccessOption = outputsForm.watch(`outputs.${props.outputId}.xChatAccessOption`);

  return (
    <SelectSimple
      options={
        new Map([
          ['1', 'No one'],
          ['3', 'Verified accounts'],
          ['4', 'Accounts I follow'],
          ['5', 'My subscribers'],
          ['2', 'Everyone'],
        ])
      }
      label="Chat access"
      value={chatAccessOption}
      onChange={(next) =>
        outputsForm.setValue(`outputs.${props.outputId}.xChatAccessOption`, next as typeof chatAccessOption)
      }
    />
  );
}
